import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement, useMemo } from "react";
import { TAccount } from "../../../../api/v1_0";
import { useStore } from "../../../../store";
import { Saving } from "./_dependencies";
import { ISavingsProps } from "./types";

export const Savings: FunctionComponent<ISavingsProps> = observer(
  (props: ISavingsProps): ReactElement<ISavingsProps> => {
    const { addAccount, closeAccount, openAccount, ...restProps } = props;
    const store = useStore();
    const savings: Array<TAccount> = useMemo(
      () =>
        [...store.wallet.savings.values()].map((saving) => ({
          ...saving,
        })),
      [store.wallet.accounts, store.operations.accounts]
    );

    return (
      <div className="contentBox marginBottom whiteBlockBg">
        <div className="contentBoxHeader">
          <h3>Счета</h3>
          {false && (
            <a href="#" className="link" onClick={addAccount}>
              Добавить
            </a>
          )}
        </div>
        <div className="row">
          {savings.map((saving) => (
            <Saving key={saving.uuid} saving={saving} onPress={openAccount} />
          ))}
        </div>
      </div>
    );
  }
);
